// extracted by mini-css-extract-plugin
export var md = "_51-4";
export var semantic = "_51-5";
export var sm = "_51-3";
export var text = "_51-6";
export var toggleInput = "_51-0";
export var toggleSwitch = "_51-1";
export var xs = "_51-2";